var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.loading)?_c('div',{staticClass:"loading",staticStyle:{"height":"300px"}},[_c('Loading')],1):_c('FilmLinksItem',{attrs:{"links":_vm.links_data}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }